export default {
	ApiHost: 'https://pop.snj.lu/api',
	AssetsUrl: "http://pop.snj.lu/assets/",
	PicturePath: "shared",
	PragmaToken: 'default=Pie,T<ethoh6mohlaecie<Sh4thahc7vait:',
	GoogleMapsApiKey: 'AIzaSyDPiwyWzY8eY0Gyjxwpp2jd7GXqQxtbSdQ', // A UTILISER UNIQUEMENT POUR BEE SECURE EN PROD
	GoogleRecaptcha: '6LckMZIoAAAAAA1bxxCoeaY_J1w_sLARAHKvHOX1'
}
